import React, { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import PortfolioSection from '../components/PortfolioSection';
import AboutSection from '../components/AboutSection';
import CareerSection from '../components/CareerSection';
import ServicesSection from '../components/ServicesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
// import ClientLogosCarousel from '../components/ClientLogosCarousel';

const HomePage = () => {
  const [userData, setUserData] = useState(null);

  // SCROLL TO TOP IMMEDIATELY
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const savedUserData = sessionStorage.getItem('userData');
    if (savedUserData) {
      // User has data in this session, load it
      setUserData(JSON.parse(savedUserData));
    }
  }, []);

  return (
    <>
      <Navigation userData={userData} />
      <main>
        <HeroSection userData={userData} />
        {/* <ClientsCarousel /> */}
        <PortfolioSection />
        <AboutSection userData={userData} />
        <CareerSection />
        <ServicesSection />
        <TestimonialsSection userData={userData} />
        <ContactSection userData={userData} />
        
        {/* Logo Background Section */}
        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-black/40"></div>
          <div 
            className="relative z-10 opacity-40 min-h-[200px] sm:min-h-[400px]"
            style={{
              backgroundImage: 'url(/All_Logo.png)',
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              filter: 'blur(1px)',
            }}
          />
          {/* Top fade to black */}
          <div 
            className="absolute top-0 left-0 right-0 z-20 pointer-events-none h-[100px] sm:h-[150px]"
            style={{
              background: 'linear-gradient(to bottom, rgba(0,0,0,1) 0%, rgba(0,0,0,0.7) 50%, rgba(0,0,0,0) 100%)'
            }}
          />
          {/* Bottom fade to black */}
          <div 
            className="absolute bottom-0 left-0 right-0 z-20 pointer-events-none h-[100px] sm:h-[150px]"
            style={{
              background: 'linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,0.7) 50%, rgba(0,0,0,0) 100%)'
            }}
          />
        </section>
        {/* <ClientLogosCarousel /> */}


      </main>
      <Footer userData={userData} />
    </>
  );
};

export default HomePage;
